import { render } from "./AfterSave.vue?vue&type=template&id=0069f8c6&scoped=true"
import script from "./AfterSave.vue?vue&type=script&lang=js"
export * from "./AfterSave.vue?vue&type=script&lang=js"

import "./AfterSave.vue?vue&type=style&index=0&id=0069f8c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0069f8c6"

export default script